import script from "./SupportButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupportButton.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__